import React from "react";
import { LucideIcon } from "lucide-react";
import { GenieIcon } from "@/components/ui/genie-icons/GenieIcon";
import type { GenieIconName } from "@/components/ui/genie-icons/genie-icons";

interface PageHeaderProps {
  title: string;
  icon?: LucideIcon;
  genieIcon?: GenieIconName;
  subtitle?: string;
  /** Optional quiet element rendered inline beside the subtitle (e.g., a "Learn more" link). */
  subtitleMeta?: React.ReactNode;
  /** Optional content rendered on the trailing side (e.g., Learn-more button). */
  action?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  icon: Icon,
  genieIcon,
  subtitle,
  subtitleMeta,
  action,
}) => (
  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-8">
    <div className="flex items-center">
      {genieIcon ? (
        <GenieIcon name={genieIcon} size={32} className="h-7 w-7 md:h-8 md:w-8 mr-3 md:mr-4" />
      ) : Icon ? (
        <div className="h-10 w-10 rounded-full bg-genie-primary/10 flex items-center justify-center mr-4">
          <Icon className="h-5 w-5 text-genie-primary" />
        </div>
      ) : null}
      <div>
        <h1 className="text-3xl font-bold text-[#222B45]">{title}</h1>
        {subtitle || subtitleMeta ? (
          <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1">
            {subtitle ? (
              <p className="text-sm md:text-base text-[#64748B] hidden sm:block">{subtitle}</p>
            ) : null}
            {subtitleMeta}
          </div>
        ) : null}
      </div>
    </div>
    {/*
      WorkspaceSwitcher is fixed at `right-6 top-5` (md and up) and owns the top-right
      corner, so header actions have to stop short of it instead of sliding underneath.
    */}
    {action ? <div className="flex-shrink-0 md:pr-[104px]">{action}</div> : null}
  </div>
);

export default PageHeader;
